import React from 'react';
import { useSelector } from 'react-redux';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import { TestimonialType } from '../types';
import { completedSteps } from '../constants';
import { roundCheckmarkSrc, adobeLogoSrc, feedbackAuthorAvatarSrc } from './images';
import './CreateAccountModalContentArea.scss';

const defaultTestimonial = {
  authorAvatarSrc: feedbackAuthorAvatarSrc,
  authorName: 'Mary Sheehan',
  address: 'Sr. Manager of PMM at',
  orgLogoSrc: adobeLogoSrc,
  feedback:
    'Now more than ever, managers must have systems in place that ensure clear communication and alignment across their team.',
};

type Props = {
  testimonial?: TestimonialType;
  showCompletedSteps?: boolean;
};

function CreateAccountModalContentArea({
  testimonial: { authorAvatarSrc, authorName, address, orgLogoSrc, feedback } = defaultTestimonial,
  showCompletedSteps = true,
}: Props) {
  const numSteps: number = useSelector(state => state.onboardingState.numSteps);

  return (
    <div className="create-account-modal-content-area p-3 pb-5 d-flex flex-column justify-content-between">
      <CharmaLogo width="180" className="mb-4 pb-3" />
      {showCompletedSteps &&
        completedSteps.slice(0, numSteps).map(step => (
          <div key={step} className="d-flex mb-3">
            <img src={roundCheckmarkSrc} className="mr-3" alt="round-checkmark" />
            <div className="create-account-modal-completed-step">{step}</div>
          </div>
        ))}
      <div className="create-account-modal-feedback p-3 position-relative">
        <img
          className="create-account-modal-feedback-author-avatar position-absolute"
          width="50"
          src={authorAvatarSrc}
          alt={authorAvatarSrc}
        />
        <div className="create-account-modal-feedback-author pt-3">{authorName}</div>
        <div className="create-account-modal-feedback-address d-flex mb-2">
          {address}
          {orgLogoSrc && <img className="ml-2 align-self-center" width="70" src={orgLogoSrc} alt={orgLogoSrc} />}
        </div>
        <p className="pr-1">“{feedback}”</p>
      </div>
    </div>
  );
}

export default CreateAccountModalContentArea;
